
angular.module('listviewModule').component('listviewSort', {
	templateUrl: 'listviewSort/listviewSort.html',
	bindings: {
		columnTitle: '@',
		sort: '@',
		sortid: '@',
		currentSort: '=',
		currentDir: '=',
		onSubmit: '&'
	},
	controller: ['$element', function($element) {
		this.sortings = {};

		this.sortUp = function(e) {
			if (e && e.stopPropagation) {
				e.stopPropagation();
				e.preventDefault();
			}

			this.sortings.sort = this.sort;
			this.sortings.dir = 1;
			this.sortings.id = this.sortid;
			this.currentDir = this.sortings.dir;
			this.currentSort = this.sort;

			this.sortSubmit(this.sortings);
		};

		this.sortDown = function(e) {
			if (e && e.stopPropagation) {
				e.stopPropagation();
				e.preventDefault();
			}

			this.sortings.sort = this.sort;
			this.sortings.dir = 2;
			this.sortings.id = this.sortid;
			this.currentDir = this.sortings.dir;
			this.currentSort = this.sort;

			this.sortSubmit(this.sortings);
		};

		this.switchSort = function() {
			if (this.currentSort === this.sort) {
				this.sortings.dir = this.currentDir === 2 ? 1 : 2;
			} else {
				this.sortings.dir = 2;
			}

			this.sortings.sort = this.sort;
			this.sortings.id = this.sortid;
			this.currentDir = this.sortings.dir;
			this.currentSort = this.sort;

			this.sortSubmit(this.sortings);
		};

		this.sortAps = function(orderVal) {
			if (this.orderProp !== orderVal) {
				this.orderProp = orderVal;
			} else {
				return;
			}
		};

		this.sortSubmit = function(sorting) {
			this.onSubmit({val: sorting});
		};
	}]
});
